"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = exports.TimeoutError = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const intercept_1 = require("./intercept");
const interceptor_1 = require("./logging/interceptor");
const p_timeout_1 = __importDefault(require("p-timeout"));
class TimeoutError extends Error {
    constructor(timeout) {
        super(`fetch timed out after ${timeout} milliseconds`);
        this.name = 'ETIMEOUT';
    }
}
exports.TimeoutError = TimeoutError;
exports.fetch = (...args) => {
    var _a, _b;
    let f = cross_fetch_1.default;
    const logger = (_a = args[1]) === null || _a === void 0 ? void 0 : _a.logger;
    const timeout = (_b = args[1]) === null || _b === void 0 ? void 0 : _b.timeout;
    if (timeout) {
        // wrap the fetch with pTimeout
        f = (...args) => {
            return p_timeout_1.default(cross_fetch_1.default(...args), timeout, new TimeoutError(timeout));
        };
    }
    if (logger) {
        f = intercept_1.intercept(new interceptor_1.LoggingInterceptor({ logger }), f);
    }
    return f(...args);
};
